const state = {
  id: null,
  content_express_agency_name: '',
  display_name: '',
  office: '',
  owner: '',
}

export const requiredFields = [{ key: 'display_name' }, { key: 'owner' }, { key: 'content_express_agency_name' }]

export default state
